import React, { useState,useEffect } from "react";
import BackButton from "./BackButton";
import { useDispatch, useSelector } from "react-redux";
import { login_user } from "../../features/userSlice";
import { msgAccessPromt } from "../../constant/constant";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
const Login_mpin = () => {
    const [mpin, setMpin] = useState(["", "", "", ""]);
    const { isUserLogedIn } = useSelector((state) => state.users);
    const navigate = useNavigate();
    const dispatch = useDispatch();
       const handleInputChange = (index, value, type) => {
        if (!/^\d*$/.test(value)) return; // Restrict to digits only

        const updatedValues = type === "mpin" ? [...mpin] : '';
        updatedValues[index] = value;

        if (type === "mpin") {
            setMpin(updatedValues);
        }

        // Automatically move to the next input
        if (value && index < 5) {
            const nextInput = document.getElementById(`${type}-${index + 1}`);
            if (nextInput) nextInput.focus();
        }
    };

      const handleSubmit = async(e) => {

          let val=0;
         msgAccessPromt({dispatch,msg:'LOADING',error:true});
           if(!(mpin[0] && mpin[1] && mpin[2] && mpin[3]))
            {
                msgAccessPromt({dispatch,error:true,msg:'Only 4 digit allow !!'});
                return false;
                }else{
                    val=mpin.reduce((acc, num) => parseInt(acc + num), 0);;
                }
            e.preventDefault();
            let dataSet = new FormData();
            const userPhone = localStorage.getItem('phone_number');
            const user_token = localStorage.getItem('user_token');
            dataSet.append('phone_number',userPhone);
            dataSet.append('password',val);
            dataSet.append('token_id',user_token);
    
            try {
                 dispatch(login_user(dataSet)); // Unwrap to get the resolved value
               
            } catch (error) {
                msgAccessPromt({dispatch,error:true,msg:'Api Error'});
            }
            
            
        };
 useEffect(()=>{
         if(isUserLogedIn){
             navigate("/home");
         }
     },[isUserLogedIn]);
      
    return (
        <div className="bodyDiv">
        <div className="mpin-container">
            <BackButton></BackButton>
                <div style={{marginTop:'27%'}}>
                <div className="title_Form" style={{justifyContent:'space-between'}}>
                    <div className="title_left">
                        <h1 className="main_title">MPIN</h1>
                        <p>Create MPIN for login</p>
                        </div>
                        <div className="title_right">
                            <FontAwesomeIcon icon={faLock} color="red" size="3x" padding='3%' />
                            
                        </div>
                </div>
            <div className="input-group">
                <label>Enter MPIN</label>
                <div className="mpin-input">
                    {mpin.map((value, index) => (
                        <input
                            key={index}
                            id={`mpin-${index}`}
                            type="password"
                            className="input_lable_deep"
                            maxLength="1"
                            value={value}
                            onChange={(e) => handleInputChange(index, e.target.value, "mpin")}
                        />
                    ))}
                </div>
            </div>
           
            <button onClick={handleSubmit} className="generate-mpin-button">Login</button>
        </div>
        </div>
        </div>
    );
};

export default Login_mpin;
